import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-vmou';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import styles from './batchtable.module.css';
import { ProgressSpinner } from 'primereact/progressspinner';

const Examinerreport = (props) => {

    const [batches, setBatches] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setloading] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);

    const exams = [
        "JUNE22",
        "DEC22",
        "JUNE23"
    ]
    const [selectedExam, setSelectedExam] = useState(exams[0]);

    useEffect(() => {
        setloading(true);
        let authOptions = {
            method: 'PUT',
            url: '/batch/Coord/', 
            data: {'userid':props.userid,'exam':selectedExam, 'sts': 'All'},
                headers : {
                'x-auth-token' : localStorage.getItem('token')
            }
        };
        axios(authOptions)
        .then(response => {
            const nbat = response.data.map(e => {
                let daydiff=""
                if (!e.dtsend)
                    daydiff=""
                else 
                    if (!e.dtsubmitted)
                        daydiff = parseInt((new Date() - new Date(e.dtsend)) / (1000 * 60 * 60 * 24), 10).toString(); 
                    else
                        daydiff = parseInt((new Date(e.dtsubmitted) - new Date(e.dtsend)) / (1000 * 60 * 60 * 24), 10).toString(); 
                return ({...e, 'days':daydiff})
            })
            setBatches(nbat)
            setloading(false)
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setBatches([]);
        });
    },[props.userid,selectedExam]); 

    const examSearch = (event) => {
        event.preventDefault();  
        setloading(true);
       let authOptions = {
        method: 'PUT',
        url: '/batch/Coord/', 
        data: {'userid':props.userid,'exam':selectedExam, 'sts': 'All'},
        headers : {
            'x-auth-token' : localStorage.getItem('token')
        }
      };
      axios(authOptions)
      .then(response => {
        const nbat = response.data.map(e => {
            let daydiff=""
            if (!e.dtsend)
                daydiff=""
            else 
                if (!e.dtsubmitted)
                    daydiff = parseInt((new Date() - new Date(e.dtsend)) / (1000 * 60 * 60 * 24), 10).toString(); 
                else
                    daydiff = parseInt((new Date(e.dtsubmitted) - new Date(e.dtsend)) / (1000 * 60 * 60 * 24), 10).toString(); 
            return ({...e, 'days':daydiff})
        })
        setBatches(nbat)
        setloading(false);
      })
      .catch(error => {
        toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
        setBatches([]);
    });
    }
    
    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const header = (
        <div className={styles.tableheader}>
            <h4 className="mx-0 my-1">Examiners</h4>
            <Button label="Export" icon="pi pi-upload" className="p-button-help mr-6" onClick={exportCSV} />
            <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return (dt)?day+"-"+month+"-"+cdt.getFullYear():'' ;
      };
    
    
    const dateBodyTemplate = (rowData) => formatDate(rowData.dtrecd);
    const dateBodyTemplate1 = (rowData) => formatDate(rowData.dtsend);
    const dateBodyTemplate2 = (rowData) => formatDate(rowData.dtsubmitted);
//            <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} selection={selectedBatches} onSelectionChange={(e) => setSelectedBatches(e.value)}
    let reptable = <div className={styles.card}>
        <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batches} 
            dataKey="ccode" sortField="ccode" sortOrder={1} paginator rows={25} rowsPerPageOptions={[25, 50, 100]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} batches"
            globalFilter={globalFilter} header={header} responsiveLayout="scroll">
            <Column field="ccode" header="Course/Paper" sortable style={{textAlign:'center',   width: '15%', padding:'0 1px 0 1px' }}></Column>
            <Column field="batchcode" header="Batch/Examiner No" sortable style={{textAlign:'center',   width: '15%' , padding:'0 1px 0 1px'}}></Column>
            <Column field="totalcopies" header="Total" style={{textAlign:'center',   width: '10%' , padding:'0 1px 0 1px'}}></Column>
            <Column field="examinerid.name" header="Examiner" sortable style={{ textAlign:'left',  width: '20%', padding:'0 1px 0 1px' }}></Column>
            <Column field="dtsend" header="Date Send" body={dateBodyTemplate1} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
            <Column field="dtsubmitted" header="Date Submit" body={dateBodyTemplate2} sortable style={{ textAlign:'center',  width: '10%' , padding:'0 1px 0 1px'}}></Column>
            <Column field="dtrecd" header="Date Recd" body={dateBodyTemplate} sortable style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
            <Column field="days" header="Days" sortable style={{textAlign:'center', width: '10%' , padding:'0 1px 0 1px'}}></Column>
        </DataTable>
    </div>
    if (loading)  
        reptable = <ProgressSpinner style={{marginTop:'20%', marginLeft:'48%', width: '40px', height: '40px'}} strokeWidth="6"  animationDuration=".7s"/> //<Spinner />

    return (
    <div className={styles.datatablecruddemo}>
        <Toast ref={toast} />
        <div className={styles.Sformpr}>
            <div className=" ">
                <label htmlFor="centre" className="">Select Exam</label>
                <Dropdown className="ml-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
            </div>
            <Button icon="pi pi-search" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
        </div>
        {reptable}
    </div>
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
  }
  
  export default connect(mapStateToProps)(Examinerreport);